// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"836":"1b31f4f5","965":"7279f182"}[chunkId] + ".chunk.js";
};